"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiClubRepo = createApiClubRepo;
const HTTPClient_1 = require("../../../common/api/HTTPClient");
const http_helpers_1 = require("../../../common/api/http-helpers");
const ClubMapper_1 = require("./mappers/ClubMapper");
const getApiUrl_1 = require("../../../common/api/utils/getApiUrl");
function createApiClubRepo() {
    return {
        getAll,
    };
}
async function getAll(page = 1, pageSize = 10) {
    const url = (0, getApiUrl_1.getApiUrl)(`/v1/clubs`);
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/clubs`),
            params: {
                page,
                pageSize,
            },
        });
        const clubs = res.map(ClubMapper_1.mapToDomainClub);
        (0, http_helpers_1.sendSuccessStatus)();
        return clubs;
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return [];
    }
}
